/**
 * Builds a new instance of the TextMenu module.
 * @module TextMenu
 * @constructor
 */

/** @lends module:TextMenu */
function TextMenu (scope, util, element, params) {
    var that = this;
    var resizeTimer;
    that.attribute = 'data-stry-text-menu';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> TextMenu -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> TextMenu -> No util available.'); return; }
        if (!element) { console.error('StoryStream -> TextMenu -> No element available.'); return; }
        if (!params) { console.error('StoryStream -> TextMenu -> No params provided.'); return; }

    }
    /*  End  */

    that.elem = element;
    that.menu_elem = undefined;
    that.menu_elem_height = 0;


    /**
     * Funnel all events through this method and distribute.
     * @memberof TextMenu
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e) {
        var type = e.type ? e.type : e.name;
        switch(type) {
            case 'viewport.scroll':

                whenViewPortScrolls(e.detail);

                break;
        }
    };


    /**
     * Function to build menu based on active page and the headers within the body text
     * @memberof TextMenu
     * @function willConstructMenuContents
     * @inner
     */
    var willConstructMenuContents = function () {
        var h2_headers = that.elem.getElementsByTagName('h2');
        var header_item;
        var header_link;
        var header_list;
        var header_text;
        var index = 0;
        var len = h2_headers.length;
        var selected_item;

        //  Only construct elements if section headers are present
        if (len) {

            //  Find the parent menu item that is selected (we add the sub menu into here).
            selected_item = that.menu_elem.getElementsByClassName('is-current')[0];

            //  Create list element
            header_list = document.createElement('ul');
            header_list.className = "text-auto-list";

            //  Loop through each header creating menu items
            while (len--) {

                //  Create new header link elements
                header_item = document.createElement('li');
                header_link = document.createElement('a');

                //  Define the header text from the element
                header_text = h2_headers[index].innerHTML;

                //  Create and add an ID attribute for the header element for linking
                h2_headers[index].id = util.slugify(header_text);

                //  Add attributes for link item element
                header_item.className = "text-auto-item";

                //  Add attributes for link element
                header_link.href = "#" + util.slugify(header_text);
                header_link.title = header_text;
                header_link.innerHTML = header_text;

                //  Assemble the finished element
                header_item.appendChild(header_link);
                header_list.appendChild(header_item);

                //  Increment for order
                index += 1;
            }

            //  Append new section menu to parent element
            selected_item.appendChild(header_list);
        }

        //  Update menu height after contents added (used for sticky menu functionality)
        that.menu_elem_height = that.menu_elem.getBoundingClientRect().height;
    };


    /**
     * Control what happens on scroll events (largely around the menu element).
     * @memberof TextMenu
     * @function handleEvent
     * @param {object} e - Scroll event data.
     * @inner
     */
    var whenViewPortScrolls = function (e) {
        var available_space;
        var module = that.elem.getElementsByClassName('module-content')[0];
        var module_inner = that.elem.getElementsByClassName('module-inner')[0];
        var offset_padding = window.getComputedStyle(module_inner, null).getPropertyValue('padding-top');
        var offset_top = module.offsetTop - e.offset_header;
        var offset_bottom = module.offsetTop + module.getBoundingClientRect().height - parseInt(window.getComputedStyle(module_inner, null).getPropertyValue('padding-bottom'));

        //  Normalise offset padding to account for undefined value
        offset_padding = offset_padding ? parseInt(offset_padding) : 0;

        //  Compensate for padding with bottom offset value
        offset_bottom = offset_bottom - offset_padding;

        //  Calculate available space for menu to appear in
        available_space = offset_bottom - (e.offset_y + e.offset_header);

        //  Add the sticky class to the navbar when you reach its scroll position.
        if (e.offset_y >= offset_top) {
            util.addClass(that.menu_elem.parentNode, "is-sticky");
            util.removeClass(that.menu_elem.parentNode, "is-bottom");
        }

        //  Remove "sticky" when you leave the scroll position
        else {
            util.removeClass(that.menu_elem.parentNode, "is-sticky");
            util.removeClass(that.menu_elem.parentNode, "is-bottom");
        }

        // Stick menu to the bottom if the legal copy is at the bottom and the available space is less than the height of the mene
        if (offset_bottom <= (e.offset_y + window.innerHeight) && available_space <= that.menu_elem_height) {
            util.removeClass(that.menu_elem.parentNode, "is-sticky");
            util.addClass(that.menu_elem.parentNode, "is-bottom");
        }
    };


    /**
     * Function used to initialise the application.
     * @memberof TextMenu
     * @function init
     * @inner
     */
    var init = function () {

        //  Define the menu element for this instance
        that.menu_elem = that.elem.getElementsByClassName('text-menu')[0];
        that.menu_elem_height = that.menu_elem.getBoundingClientRect().height;

        //  Build the section menu list if necessary
        if (that.elem.hasAttribute('data-stry-text-menu-generate')) {

            willConstructMenuContents();
        }


        //  Listen for all click events
        scope.addEventListener("viewport.scroll", handleEvent, false);
    };


    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.TextMenu = TextMenu;
}
